module.exports = __webpack_public_path__ + "static/no-image-d7016d9394fd949b03df3ac511f792d7.png";